import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=b36f9426&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=b36f9426&prod&lang=scss&scoped=true"
import style1 from "./Main.vue?vue&type=style&index=1&id=b36f9426&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36f9426",
  null
  
)

export default component.exports